import { Type } from 'class-transformer'
import { Entity } from '..'

import { FileType } from '.'

class PostJob {
  setExpirationDate: {
    daysToExpire: number
  }
}

class Config {
  @Type(() => PostJob)
  postJobs: PostJob
}

export class Serialization extends Entity {
  @Type(() => FileType)
  fileType: FileType;

  @Type(() => Config)
  config: Config;

  service: string;
}
